export {
  default,
  default as ErrorBoundary,
  SectionErrorBoundary,
  withErrorBoundary
} from './ErrorBoundary';
export { default as ErrorBoundaryFallbackComponent } from './ErrorBoundaryFallbackComponent';
export type { OwnProps as ErrorBoundaryFallbackComponentProps } from './ErrorBoundaryFallbackComponent';
